import React from 'react';
import { useFavorites } from '../context/FavoritesContext';
import ProductCard from '../components/ProductCard';
import { Link } from 'react-router-dom';

function MisFavoritosPage() {
    const { favorites, loadingFavorites, authChecked } = useFavorites();

    const renderContent = () => {
        // Esperando a que el contexto cargue los favoritos
        if (loadingFavorites || !authChecked) {
            return <div className="text-center">Cargando favoritos...</div>;
        }

        // Si no hay favoritos
        if (favorites.length === 0) {
            return (
                <div className="text-center">
                    <p>No tienes ningún artículo guardado en favoritos.</p>
                    <Link to="/" className="btn btn-primary">
                        Explorar productos
                    </Link>
                </div>
            );
        }

        // Mostrar la cuadrícula de favoritos
        return (
            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4">
                {favorites.map((item) => (
                    <div className="col" key={item.id}>
                        {/* ProductCard ahora obtendrá 'isFavorited'
                          directamente del contexto, así que no
                          necesitamos pasárselo como prop.
                        */}
                        <ProductCard item={item} />
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div>
            <h2 className="mb-4">Mis Favoritos</h2>
            {renderContent()}
        </div>
    );
}

export default MisFavoritosPage;
